import { useServices } from './useServices';

export const useCalendar = () => {
  return useServices().calendar;
};
